<template>
  <div class="single-blog-view">
    <v-container>
      <section class="single-blog-section" v-if="Object.entries(items).length > 0">
        <div class="blog-header">
          <h1 class="blog-main-title">
            {{ $t("Blog") }}
          </h1>
          <p class="blog-subtitle">
            {{ $t("Through_section") }}
          </p>
        </div>

        <article class="blog-article">
          <div class="blog-image-container">
            <img :src="items.image" :alt="items.title" class="blog-featured-image" />
          </div>
          
          <div class="blog-content-wrapper">
            <div class="blog-meta">
              <h2 class="blog-title">
                {{ items.title }}
              </h2>
              <div class="blog-date">
                <v-icon icon="mdi-clock-time-five-outline" size="18"></v-icon>
                <span>{{ items.date }}</span>
              </div>
            </div>
            <div class="blog-description" v-html="items.description"></div>
          </div>
        </article>
      </section>
    
      <v-row v-else>
        <v-col cols="12">
          <v-skeleton-loader
            class="mx-auto border-0"
            type="image,paragraph"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12">
          <v-skeleton-loader
            class="mx-auto border-0"
            type="image,paragraph"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import crudDataService from "@/Services/crudDataService";
export default {
  data() {
    return {
      items: [],
      itemsPerRow: 3,
    };
  },

  methods: {
    async singleblog() {
      let response = await crudDataService.get(
        "blogs",
        `${this.$route.params.id}`
      );
      this.items = response.data.data;
      console.log(this.items);
    },
  },
  mounted() {
    this.singleblog();
  },
};
</script>

<style lang="scss" scoped>
.single-blog-view {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding: 32px 0;
}

.single-blog-section {
  max-width: 900px;
  margin: 0 auto;
}

.blog-header {
  text-align: center;
  margin-bottom: 40px;
}

.blog-main-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.blog-subtitle {
  font-size: clamp(16px, 2.5vw, 20px);
  color: #666;
  font-weight: 400;
  margin: 0;
}

.blog-article {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.blog-image-container {
  width: 100%;
  height: 400px;
  overflow: hidden;
  background: #f5f5f5;
  
  @media (max-width: 600px) {
    height: 250px;
  }
}

.blog-featured-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blog-content-wrapper {
  padding: 32px;
  
  @media (max-width: 600px) {
    padding: 24px;
  }
}

.blog-meta {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.blog-title {
  font-size: clamp(20px, 3vw, 28px);
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.4;
}

.blog-date {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
}

.blog-description {
  font-size: clamp(15px, 2vw, 18px);
  color: #333;
  line-height: 1.8;
  
  :deep(p) {
    margin-bottom: 16px;
  }
  
  :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 16px 0;
  }
}

@media (max-width: 600px) {
  .single-blog-view {
    padding: 24px 0;
  }
  
  .blog-header {
    margin-bottom: 32px;
  }
}
</style>
